var router = require('pjax').Router;
var index = require('./index.js');

router.get('/', index);
router.get('/password/confirm/:any', index);
router.get('/register/([a-zA-Z]+)', index);
router.get('/saml/link-account/:any', index);
